(function () {
  window.guide = {}; // Нельзя удалять до переделки Guide. построение точек по этому массиву
})();

(function () {
  window.event_link = 'vlink';
  window.event_double_click = 'v_double_click';
  window.event_action_move = 'vmove';
  window.event_action_leave = 'vleave';
  window.event_animated_end = 'event_animated_end_';
  window.event_channels_ready = 'channelsReady';
})();

(function () {
  // import cursorAnimation
  // HotezaTV
  // time
  // log
  // css_transform
  // css_transition
  // css_transitionend
  // css_animationend
  // css_append
  // get_language
  // $
  // log
  // makeClickable
  // shop_init_prices
  // isset
  // version
  // build_rcu
  // active_page
  // active_page_id
  // config
  // hash
  // PreloadMedia
  // LPBar

  var preload_starttime = 0;

  // this one is called after all modules been loaded
  function document_ready() {
    cursorAnimation();
    HotezaTV.metrics.modules = time.uptime();
    log.add('doc ready');

    //Проверка поддержки трансформаций (префиксы)
    if (typeof document.body.style.transform !== 'undefined') {
      //console.log('transform');
      window.css_transform = 'transform';
      window.css_transition = 'transition';
      window.css_transitionend = 'transitionend';
      window.css_animationend = 'animationend';
    }
    if (typeof document.body.style.webkitTransform !== 'undefined') {
      //console.log('webkitTransform');
      window.css_transform = '-webkit-transform';
      window.css_transition = '-webkit-transition';
      window.css_transitionend = 'webkitTransitionEnd';
      window.css_animationend = 'webkitAnimationEnd';
    }
    if (typeof document.body.style.OTransform !== 'undefined') {
      //console.log('operaTransform');
      window.css_transform = '-o-transform';
      window.css_transition = '-o-transition';
      window.css_transitionend = 'oTransitionEnd';
      window.css_animationend = 'oAnimationEnd';
    }

    log.add('added styles');

    makeClickable();
    log.add('Event listeners added');

    //Форматирование цен магазина
    shop_init_prices();
    log.add('shop prices init');

    // Загрузка корзины
    // shop_load();
    // log.add('shop loaded');

    if (isset('config.tv.roomcontrol')) {
      css_append('s/rcu.css');
      css_append('s/font/RCU/style.css');
      $.cachedScript('j/rcu.js?v=' + version.v).done(function () {
        build_rcu();
      });
    }

    /*
    //Переход на последнюю страницу
    var tmp = HotezaTV.history.lastpage;
    if(tmp && $(tmp).length){
      navigate(tmp);
    }else{
      //по умолчанию
      navigate('#shop');
    }
    */
    window.active_page = '';
    window.active_page_id = '';

    //preload images
    preload_start();

    // TODO: EXPERIMENTAL FUNCTIONALITY
    if (isset('config.tv.marquee')) {
      MarqueeService.init();
    }
  }

  function preload_start() {
    preload_starttime = Date.now();
    if (isset('config.preload_images') == undefined) {
      config.preload_images = 1;
    }

    // this added for quick run app in a browser
    if (hash.get('preload_images')) {
      config.preload_images = parseInt(hash.get('preload_images'));
    }

    switch (isset('config.preload_images')) {
      case 1:
        log.add('Preload: type 1');

        new PreloadMedia('body').progress(LPBar.preload_progress.bind(LPBar)).done(function (total) {
          preload_end(total);
        });

        break;

      case 2:
        log.add('Preload: type 2');

        new PreloadMedia('body').progress(LPBar.preload_progress.bind(LPBar)).done(function (total) {
          preload_end(total);
        });

        break;

      case 3:
        log.add('Preload: type 3, runtime');

        new PreloadMedia('body').progress(LPBar.preload_progress.bind(LPBar)).done(function (total) {
          preload_end(total);
        });

        break;

      case 0:
      case false:
        log.add('Preload: off');

        $('[image_url]').each(function () {
          var src = $(this).attr('image_url');

          if (src) {
            if (this.tagName.toLowerCase() === 'img') {
              $(this).attr('src', src);
            } else {
              this.style.cssText = this.style.cssText.replace(
                'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=',
                src,
              );
            }
          }

          $(this).removeAttr('image_url');
        });

        preload_end(0);
        break;
      default:
        break;
    }
  }

  function preload_end(total) {
    log.add('Preloaded ' + total + ' pics in ' + (Date.now() - preload_starttime) + ' ms');

    LPBar.hide();

    document.getElementById('container').style.visibility = 'visible';

    log.add('Splash show');
    $('#splashscreen').show();
    HotezaTV.metrics.splash = time.uptime();
    $(HotezaTV).trigger('splashshow');
  }

  window.document_ready = document_ready;
})();

(function () {
  function filter_content_by_group() {
    var tmp_i = 0;
    var tmp_i2 = 0;
    var tmp_o = 0;
    var tmp_t = $('[groups]').length;
    var start = Date.now();
    $('[groups]').each(function () {
      var tmp = this.getAttribute('groups');
      if (tmp == '' || tmp == '[]' || tmp == '[""]') {
        this.removeAttribute('groups');
        tmp_o++;
        //console.log('empty');
      } else {
        try {
          tmp = JSON.parse(tmp);
        } catch (e) {
          tmp = false;
        }

        if (
          tmp &&
          guestData &&
          guestData.groups &&
          tmp.filter(function (n) {
            return guestData.groups.indexOf(n.toString()) != -1;
          }).length
        ) {
          this.classList.remove('forbidden_by_group');
          tmp_i++;
        } else {
          this.classList.add('forbidden_by_group');
          tmp_i2++;
          //$(this).remove();
          //console.log('hide');
        }
        //tmp = 'group_'+tmp+.join(' group_');
        //$(this).attr('groups', tmp).removeAttr('groups');
        //$(this).addClass(tmp);
        //console.log('not empty');
      }
    });

    log.add(
      'FILTER: Filtered items by group: +' + tmp_i + '|-' + tmp_i2 + '|' + tmp_t + ' in ' + (Date.now() - start) + 'ms',
    );
    if (tmp_o > 0) {
      log.add('FILTER: Empty groups in item: ' + tmp_o);
    }

    //TODO: если текущая страница forbidden то переход
  }

  function filter_content_by_device(obj, device) {
    //Фильтр контента по девайсу
    //TODO: VOD тоже
    var tmp_i = 0;
    var tmp_i2 = 0;
    var tmp_o = 0;
    var objs = obj.find('[devices]');
    var tmp_t = objs.length;
    var start = Date.now();
    objs.each(function () {
      var tmp = this.getAttribute('devices');
      if (tmp == '' || tmp == '[]' || tmp == '[""]') {
        this.removeAttribute('devices');
        tmp_o++;
      } else {
        try {
          tmp = JSON.parse(tmp);
        } catch (e) {
          tmp = false;
        }
        if (tmp && tmp.indexOf(device) == -1) {
          tmp_i++;
          $(this).remove();
        } else {
          tmp_i2++;
        }
      }
    });

    log.add('FILTER: Filtered items by device "' + device + '": +' + tmp_i2 + '/ -' + tmp_i + '/' + tmp_t);
    if (tmp_o > 0) {
      log.add('FILTER: Empty devices in item: ' + tmp_o);
    }
    log.add('FILTER: In ' + (Date.now() - start) + 'ms');

    return obj;
  }

  window.filter_content_by_group = filter_content_by_group;
  window.filter_content_by_device = filter_content_by_device;
})();

(function () {
  var lang = {};
  lang.empty = true;

  function getObjectLang() {
    if (lang.empty) {
      lang.selectTime = getlang('mobileAppContent-contentPage-input-hotelServiceRequest-selectTime');
      lang.kontinue = getlang('mobileAppContent-welcomePage-button-continue');
      lang.now = getlang('mobileAppContent-contentPage-button-hotelServiceRequest-now');
      lang.back = getlang('mobileAppContent-default-label-back');
      lang.guide = getlang('mobileAppContent-mainMenuPage-label-guide');
      lang.cart = getlang('mobileAppContent-mainMenuPage-label-cart');
      lang.cartIsEmpty = getlang('mobileAppContent-mainContent-label-cartIsEmpty');
      lang.checkOut = getlang('mobileAppContent-mainContent-button-checkout');
      lang.total = getlang('mobileAppContent-mainContent-label-total');
      lang.settings = getlang('settings');
      lang.fsupdate = getlang('mobileAppContent-mainContent-settings-fsupdate');
      lang.chooselang = getlang('mobileAppContent-mainContent-settings-chooselang');
      lang.language = getlang('mobileAppContent-mainContent-label-language');
      lang.billLoginreq = getlang('bill_loginreq');
      lang.billPage = getlang('bill_page');
      lang.feedback = getlang('mobileAppContent-mainMenuPage-label-feedback');
      lang.send = getlang('mobileAppContent-default-buttons-send');
      lang.selectrecipient = getlang('mobileAppContent-mainContent-messages-selectrecipient');
      lang.messages = getlang('messages');
      lang.addPcsToCart = getlang('mobileAppContent-mainContent-label-addPcsToCart');
      lang.addToCart = getlang('mobileAppContent-mainContent-label-addToCart');
      lang.continueshopping = getlang('mobileAppContent-mainContent-button-continueshopping');
      lang.gotocart = getlang('mobileAppContent-mainContent-button-gotocart');
      lang.shopordertext = getlang('mobileAppContent-mainContent-label-shopordertext');
      lang.order = getlang('mobileAppContent-mainContent-header-order');

      lang.controlserviceinfo = getlang('mobileAppContent-mainMenuPage-label-controlservicesinfo');
      lang.controlservicesDND = getlang('mobileAppContent-mainMenuPage-label-controlservicesDND');
      lang.controlservicescleanroom = getlang('mobileAppContent-mainMenuPage-label-controlservicescleanroom');
      lang.temperaturecontrol = getlang('mobileAppContent-mainMenuPage-label-temperaturecontrol');
      lang.curtainscontrol = getlang('mobileAppContent-mainMenuPage-label-curtainscontrol');
      lang.curtainsopen = getlang('mobileAppContent-mainMenuPage-label-curtainsopen');
      lang.lightcontrol = getlang('mobileAppContent-mainMenuPage-label-lightcontrol');
      lang.mainlight = getlang('mobileAppContent-mainMenuPage-label-mainlight');
      lang.halllight = getlang('mobileAppContent-mainMenuPage-label-halllight');
      lang.bedlight = getlang('mobileAppContent-mainMenuPage-label-bedlight');
      lang.roomcontrol = getlang('mobileAppContent-mainMenuPage-label-roomcontrol');
      lang.tvon = getlang('mobileAppContent-mainMenuPage-label-tvcontrol-tvon');
      lang.mute = getlang('mobileAppContent-mainMenuPage-label-tvcontrol-mute');
      lang.channel = getlang('mobileAppContent-mainMenuPage-label-tvcontrol-channel');
      lang.tvcontrol = getlang('mobileAppContent-mainMenuPage-label-tvcontrol');
      lang.translated = getlang('mobileAppContent-mainContent-label-translatedMessage');

      lang.service_order = getlang('service_order');
      lang.confirm = getlang('confirm');
      lang.select_time_date = getlang('select_time_date');

      lang.parental_lock = getlang('parental_lock');
      lang.parental_lock_description = getlang('parental_lock_description');
      lang.parental_lock_enabled = getlang('parental_lock_enabled');

      lang.sleep_timer = getlang('sleep_timer');
      lang.change_quantity = getlang('change_quantity');

      lang.empty = false;
    }

    return lang;
  }

  window.getObjectLang = getObjectLang;
})();
